angular.module('impactx.rfx').controller('RFXThreadListSupportCtrl',
    RFXThreadListSupportCtrl);

$inject = ["$routeParams", "selectedListItems", "$scope"];

function RFXThreadListSupportCtrl($routeParams, selectedListItems, $scope)
{
    var ctrl = this;
    ctrl.$onInit = function() {
        ctrl.conversation = $scope.trns.conversation;
        ctrl.unreadConversation = $scope.trns.unreadConversation;
    }

    this.getEdiLink = function () {
        return "rfxthread/edit/support/" + selectedListItems.getFirstSelectedItem().id + "/" + selectedListItems.getFirstSelectedItem().rfqhid
    };

    var buttonDefinition = [
        {label: "details", linkFunction: ctrl.getEdiLink, type:'link', condition:  selectedListItems.isSingleSelection, process: 'RFXThreadSupportList'}
    ];

    this.meta = {
        // singleActionsTemplate: 'modules/rfx/templates/rfx-thread-list.singleactions.tmpl.html',
        rowTemplate: 'modules/rfx/templates/rfx-thread-list.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/rfx/thread/list/support',
        id: "rfxthreadlistsupport",
        buttonDefinition: buttonDefinition,
        excelExport: true,
        valuesInteger: [
            {
                name: "RFQHId",
                value: $routeParams.id
            }
        ]
    };
    this.getMeta = function () {
        return this.meta;
    }
}